import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import MeStore from '../../mobx/me';
import Icon from '../Icon';

interface Props {
  hostKey?: string | null;
  secret?: string;
  owner?: boolean;
}

const AgentSetup = observer(({ hostKey, secret, owner = true }: Props) => {
  const { t } = useTranslation();
  const [copyStatus, setCopyStatus] = useState('');
  const accountKey = owner ? MeStore.me?.key : undefined;
  const config = `agent:
  host: whatcha.me
  check_interval: 5
  key: ${hostKey ? JSON.stringify(hostKey) : '<host-key>'}
  account_key: ${accountKey ? JSON.stringify(accountKey) : '<account-key>'}
  secret: ${secret ? JSON.stringify(secret) : '<agent_secret>'}
  log_file: ./umagent.log
server:
  host: https://api.whatcha.me`;
  const ready = Boolean(hostKey && accountKey && secret);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(config);
      setCopyStatus(t('Copied!'));
    } catch {
      setCopyStatus(t('AGENT_COPY_ERROR'));
    }
  };

  return (
    <div className="agent-setup t-body-2">
      <p>{t('AGENT_UPGRADE')}</p>
      <p>{t('AGENT_CONFIG')}</p>
      {hostKey && owner ? (
        <>
          <p>{t('AGENT_KEYS_FILLED')}</p>
          {!accountKey && <p role="alert">{t('AGENT_ACCOUNT_KEY_MISSING')}</p>}
          {!secret && <p>{t('AGENT_SECRET_HIDDEN')}</p>}
          <div className="block-copy agent-config">
            <pre className="agent-config__code"><code>{config}</code></pre>
            {ready && (
              <button type="button" className="block-copy__copy agent-config__copy" aria-label={t('AGENT_COPY_CONFIG')} onClick={copy}>
                <Icon name="copy" />
              </button>
            )}
          </div>
          {copyStatus && <p role="status">{copyStatus}</p>}
        </>
      ) : <p>{t(owner ? 'AGENT_KEYS_AFTER_CREATE' : 'AGENT_KEYS_OWNER')}</p>}
      <p>{t('AGENT_VERIFY')}</p>
    </div>
  );
});

export default AgentSetup;
